import React from 'react';
import { FormModal } from 'components/common';
import { Col, Form, Row, Select } from 'components';
import { useAssignmentEdit } from './useAssignmentEdit';
import { AdminsSelect } from 'components/common/adminsSelect';

export interface IAssignmentUpdate {
  onCancel: () => void;
  open: boolean;
}

export const AssignmentEditModal = React.memo((props: IAssignmentUpdate) => {
  const { onCancel: onCancelModal, open } = props;
  const { userData, form, isLoadingUpdate, onFinish, onCancel } = useAssignmentEdit({
    onCancelModal,
    open,
  });

  const roleMapping = {
    salesManager: 'Sales Manager',
    salesManagerAssistant: 'SM Assistant',
    purchaseManager: 'Purchase Manager',
    purchaseManagerAssistant: 'PM Assistant',
    postSalesManager: 'Post-Sales Manager',
    postSalesManagerAssistant: 'Post-SM Assistant',
  };

  return (
    <FormModal
      form={form}
      title={'Update Assignments'}
      okText={'Save'}
      open={open}
      isLoading={isLoadingUpdate}
      onCancel={onCancel}
      onSubmit={onFinish}
    >
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Form.Item label={roleMapping.purchaseManager} name={'purchaseManagerId'}>
            <AdminsSelect size={'large'} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            shouldUpdate={(prevValues: any, currentValues: any) =>
              prevValues.purchaseManagerId !== currentValues.purchaseManagerId
            }
          >
            {({ getFieldValue, setFieldValue }) => {
              const purchaseManagerId = getFieldValue('purchaseManagerId');
              const purchaseManagerAssistantId = getFieldValue('purchaseManagerAssistantId');
              if (purchaseManagerId === purchaseManagerAssistantId) setFieldValue('purchaseManagerAssistantId', '');
              return (
                <Form.Item label={roleMapping.purchaseManagerAssistant} name={'purchaseManagerAssistantId'}>
                  <Select
                    size={'large'}
                    options={userData.map((i: { value: string; label: string }) => ({
                      ...i,
                      disabled: getFieldValue('purchaseManagerId') === i.value,
                    }))}
                    disabled={!getFieldValue('purchaseManagerId')}
                  />
                </Form.Item>
              );
            }}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label={roleMapping.salesManager} name={'salesManagerId'}>
            <AdminsSelect size={'large'} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            shouldUpdate={(prevValues: any, currentValues: any) =>
              prevValues.salesManagerId !== currentValues.salesManagerId
            }
          >
            {({ getFieldValue, setFieldValue }) => {
              const salesManagerId = getFieldValue('salesManagerId');
              const salesManagerAssistantId = getFieldValue('salesManagerAssistantId');
              if (salesManagerId === salesManagerAssistantId) setFieldValue('salesManagerAssistantId', '');
              return (
                <Form.Item label={roleMapping.salesManagerAssistant} name={'salesManagerAssistantId'}>
                  <Select
                    size={'large'}
                    options={userData.map((i: { value: string; label: string }) => ({
                      ...i,
                      disabled: getFieldValue('salesManagerId') === i.value,
                    }))}
                    disabled={!getFieldValue('salesManagerId')}
                  />
                </Form.Item>
              );
            }}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label={roleMapping.postSalesManager} name={'postSalesManagerId'}>
            <AdminsSelect size={'large'} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            shouldUpdate={(prevValues: any, currentValues: any) =>
              prevValues.postSalesManagerId !== currentValues.postSalesManagerId
            }
          >
            {({ getFieldValue, setFieldValue }) => {
              const postSalesManagerId = getFieldValue('postSalesManagerId');
              const postSalesManagerAssistantId = getFieldValue('postSalesManagerAssistantId');
              if (postSalesManagerId === postSalesManagerAssistantId) setFieldValue('postSalesManagerAssistantId', '');
              return (
                <Form.Item label={roleMapping.postSalesManagerAssistant} name={'postSalesManagerAssistantId'}>
                  <Select
                    size={'large'}
                    options={userData.map((i: { value: string; label: string }) => ({
                      ...i,
                      disabled: getFieldValue('postSalesManagerId') === i.value,
                    }))}
                    disabled={!getFieldValue('postSalesManagerId')}
                  />
                </Form.Item>
              );
            }}
          </Form.Item>
        </Col>
      </Row>
    </FormModal>
  );
});
